import $ from 'jquery';
import Prefixed from 'modules/prefixed/prefixed';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-roaming-info',
			dom: {
				toogle: '.js-roaming-info-toggle'
			},
			classes: {
				state: {
					open: 'b-roaming-info_state_open'
				}
			},
			callback: {
				height: false
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.heightInterval = false;
		this.prefixed = new Prefixed();
		return this;
	}

	getDom() {
		const self = this;
		self.$toogle = $(self.options.dom.toogle);
		return self;
	}

	startHeight() {
		const self = this;
		self.heightInterval = setInterval(function () {
			if (typeof self.options.callback.height === 'function') {
				self.options.callback.height();
			}
		}, 50);
	}

	endHeight() {
		clearInterval(this.heightInterval);
		if (typeof this.options.callback.height === 'function') {
			this.options.callback.height();
		}
	}

	open() {
		this.$el.removeClass(this.options.classes.state.open);
		return this;
	}

	close() {
		this.$el.removeClass(this.options.classes.state.open);
		return this;
	}

	toogle() {
		this.startHeight();
		this.$el
			.one(this.prefixed.events.animationEnd, this.endHeight.bind(this))
			.toggleClass(this.options.classes.state.open);
		return this;
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();
			self.$toogle.on('click', self.toogle.bind(self));
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/roaming/info/info.js